const ITEMS = [
  "Stop typing. Start guiding.",
  "No monthly software fees",
  "Zero PHI — your platform, your control",
  "PIE · SOAP · DAP",
  "One license per team — owned forever",
  "Progress Notes · CCAs · PCPs",
];

export function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden border-y border-navy-700 bg-navy py-4" aria-hidden="true" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 font-mono text-xs font-semibold uppercase tracking-[0.25em] text-slate-300">
            {item}
            <span className="text-teal-500">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
